/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential.
 *
 * THE LOOK OF A CONTROL THAT CANNOT ACT (rule 4, 29/10/2026). A refused button
 * at partial opacity of its action colour still reads as live. A disabled
 * button takes a muted neutral background and text from the theme (both
 * themes define --lc39 and --lc43), a matching border, the not allowed cursor
 * and full opacity, so it is unmistakably not the action. Spread last over the
 * button's own style; the button also carries the disabled attribute.
 */
export const DISABLED_BUTTON_STYLE = Object.freeze({
  background: 'var(--lc39)',
  color: 'var(--lc43)',
  border: '1px solid var(--lc39)',
  boxShadow: 'none',
  cursor: 'not-allowed',
  opacity: 1,
});
